module.exports = "<p-confirmDialog class=\"cui-confirm-dialog\" [header]=\"title\" [icon]=\"icon\" width=\"425\" #cd>\n    <footer>\n        <button type=\"button\" pButton [label]=\"confirmLabel\" (click)=\"cd.accept()\" class=\"GreenButton btn-primary\"></button>\n        <button type=\"button\" pButton [label]=\"cancelLabel\" (click)=\"cd.reject()\" class=\"LinkButton\"></button>\n    </footer>\n</p-confirmDialog>"


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-confirm-dialog/cui-confirm-dialog.component.html
// module id = ../../../../../src/app/shared/cui-confirm-dialog/cui-confirm-dialog.component.html
// module chunks = main